import { useMatch } from "react-router";

export type LayoutRouteFlags = {
  isHomeRoute: boolean;
  isBrowseRoute: boolean;
  isProfileRoute: boolean;
  isFullWidthPage: boolean;
};

export const useLayoutRouteFlags = (): LayoutRouteFlags => {
  const isHomeRoute = Boolean(useMatch({ path: "/app/home", end: false }));
  const isBrowseRoute = Boolean(useMatch({ path: "/app/browse", end: false }));
  const isProfileRoute = Boolean(
    useMatch({ path: "/app/profile", end: false })
  );

  return {
    isHomeRoute,
    isBrowseRoute,
    isProfileRoute,
    isFullWidthPage: isHomeRoute || isBrowseRoute
  };
};
